import { DateTime } from 'luxon';

export const sortStringifiedDateTimes = (a?: string, b?: string) => {
  if (!a || !b) return 0;

  const aMilliseconds = DateTime.fromISO(a).toMillis();
  const bMilliseconds = DateTime.fromISO(b).toMillis();

  return bMilliseconds - aMilliseconds;
};
